import React from 'react';
import { Table, Pagination } from 'react-bootstrap';
import { fmtMoeda, fmtDecimal4, fmtDataNegocio } from '../helpers';

// W-0595 — grid de resultado. Paginação SERVER-SIDE: o backend /gerar devolve só a página
// corrente (itens) + total_registros. mudarPagina dispara nova chamada no container.
// Colunas espelham UQRRelNeg.pas: Código, C/V, Data, Conta, Usuário, Quantidade,
// Cotação Unit., Total, Observação. compra_venda = alias de Negocio.CompraVenda (char(1) bruto).

const RenderizarPaginacao = ({ paginaAtual, totalPaginas, mudarPagina }) => {
  if (totalPaginas <= 1) return null;

  const itens = [];
  const maxBotoes = 5;

  let inicioPaginas = Math.max(1, paginaAtual - Math.floor(maxBotoes / 2));
  const fimPaginas = Math.min(totalPaginas, inicioPaginas + maxBotoes - 1);

  if (fimPaginas - inicioPaginas < maxBotoes - 1) {
    inicioPaginas = Math.max(1, fimPaginas - maxBotoes + 1);
  }

  itens.push(
    <Pagination.First
      key="first"
      onClick={() => mudarPagina(1)}
      disabled={paginaAtual === 1}
    />
  );
  itens.push(
    <Pagination.Prev
      key="prev"
      onClick={() => mudarPagina(paginaAtual - 1)}
      disabled={paginaAtual === 1}
    />
  );

  if (inicioPaginas > 1) {
    itens.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
  }

  for (let numero = inicioPaginas; numero <= fimPaginas; numero += 1) {
    itens.push(
      <Pagination.Item
        key={`pag-${numero}`}
        active={numero === paginaAtual}
        onClick={() => mudarPagina(numero)}
      >
        {numero}
      </Pagination.Item>
    );
  }

  if (fimPaginas < totalPaginas) {
    itens.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
  }

  itens.push(
    <Pagination.Next
      key="next"
      onClick={() => mudarPagina(paginaAtual + 1)}
      disabled={paginaAtual === totalPaginas}
    />
  );
  itens.push(
    <Pagination.Last
      key="last"
      onClick={() => mudarPagina(totalPaginas)}
      disabled={paginaAtual === totalPaginas}
    />
  );

  return (
    <div className="d-flex justify-content-end align-items-center mb-2">
      <Pagination className="mb-0">{itens}</Pagination>
    </div>
  );
};

const GridResultado = ({
  itens,
  mostrarHora,
  paginaAtual,
  totalPaginas,
  totalRegistros,
  mudarPagina,
}) => {
  const lista = itens || [];

  return (
    <div className="mt-3">
      <RenderizarPaginacao
        paginaAtual={paginaAtual}
        totalPaginas={totalPaginas}
        mudarPagina={mudarPagina}
      />

      <div className="table-responsive">
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Código</th>
              <th>C/V</th>
              <th>Data</th>
              <th>Conta</th>
              <th>Usuário</th>
              <th className="text-right">Quantidade</th>
              <th className="text-right">Cotação Unit.</th>
              <th className="text-right">Total</th>
              <th>Observação</th>
            </tr>
          </thead>
          <tbody>
            {lista.map(item => (
              <tr key={`negocio-${item.codigo_negocio}`}>
                <td>{item.codigo_negocio}</td>
                <td>{item.compra_venda || ''}</td>
                <td>{fmtDataNegocio(item.data_negocio, mostrarHora)}</td>
                <td>{item.apelido_conta || ''}</td>
                <td>{item.nome_usuario || ''}</td>
                <td className="text-right">{fmtDecimal4(item.quantidade)}</td>
                <td className="text-right">
                  {fmtDecimal4(item.cotacao_unitaria)}
                </td>
                <td className="text-right">{fmtMoeda(item.total)}</td>
                <td>{item.observacao || ''}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <RenderizarPaginacao
        paginaAtual={paginaAtual}
        totalPaginas={totalPaginas}
        mudarPagina={mudarPagina}
      />

      <small className="text-muted">
        Total: {totalRegistros} registro(s) — página {paginaAtual} de{' '}
        {totalPaginas}
      </small>
    </div>
  );
};

export default GridResultado;
